/**
 * Pure decision function for the greeting speaker icon, shared by web and native so the two
 * surfaces cannot drift.
 *
 * Encodes the three-state resolved-capability model. The message snapshot
 * (`messageGreetingAudioUrl`) is the single source for static playback: a virtual
 * (pre-conversation) greeting receives it from the character when the message is created, and a
 * persisted greeting carries the server-resolved URL. Clearing that snapshot (for example after
 * the greeting is edited) removes the static route.
 *
 * The static preview is for logged-in users only, so anonymous users sign up to hear it. For an
 * anonymous user on a character with an attached voice, `route === "signIn"` keeps the speaker
 * icon visible and the caller asks them to sign in instead of playing audio.
 *
 * `route === "static"` means the caller should play `audioUrl` directly. Any other route leaves
 * existing behaviour untouched (live TTS when entitled, upgrade funnel when paywalled without a
 * valid source, no icon otherwise).
 */
export default function resolveGreetingAudioRoute({ isFeatureEnabled, isGreetingMessage, isTtsAllowed, isPaywall, isAuthenticated, hasCharacterVoice, messageGreetingAudioUrl, }) {
    if (!isFeatureEnabled || !isGreetingMessage) {
        return { route: "none" };
    }
    if (isTtsAllowed) {
        return { route: "live" };
    }
    if (!isPaywall) {
        return { route: "none" };
    }
    if (!isAuthenticated) {
        return { route: hasCharacterVoice ? "signIn" : "none" };
    }
    if (messageGreetingAudioUrl) {
        return { route: "static", audioUrl: messageGreetingAudioUrl };
    }
    return { route: "none" };
}
